import {Component} from "react";
import MessaggioRender from "./MessaggioRender.mjs";
import "./MessaggiRender.css";
import Glob from "../../../libs/Glob.mjs";
import appLib from "../../../libs/appLib.mjs";
import ModerateAction from "../Admin/ModerateAction.mjs";

const prefix = "MessaggiRender";

const MessaggiRender = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			extra: props.extre ?? { axle: !this.props.axle },
			lang: props.lang ?? Glob.getLanguage(),
			ll: props.ll ?? Glob.getLanguageLong(),
			user: props.user ?? appLib.currentUser(),
		}
		this.uid = Glob.generateUid(prefix);
	}
	componentDidMount() {
		Glob.register('ModerateAction', m => {
			this.setState({dettaglioSegnalazioni: m});
		}, this.uid)
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
	}
	render() {
		return (
			<div className={prefix}>
				{ (this.props.data || []).map( m => (
					<MessaggioRender
						key={`${m.id}-${m.updated}`}
						axle={this.props.axle}
						user={this.state.user}
						data={m}
						extra={ this.state.extra }
						lang={ this.state.lang }
						ll={ this.state.ll }
					/>
				)) }
				{ this.state.dettaglioSegnalazioni && (
					<ModerateAction user={this.state.user} data={ this.state.dettaglioSegnalazioni } />
				)}
			</div>
		)
	}
}

export default MessaggiRender;
